import { useState, useEffect } from "react";
import axios from "axios";
import { GoogleLogo } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { getErrorMessage } from "@/lib/auth";

const API = `${window.location.origin}/api`;

const OPTIONS = [
  { key: "allow_new_users", label: "Let new Google accounts join as Sales Team", hint: "Off: only emails already added in User Management can sign in with Google. Others see \"Not authorised\"." },
  { key: "sales_google_only", label: "Sales Team must use Google sign-in", hint: "On: Sales Team can't use password login or public sign-up. Admins can always use their password." },
];

export function GoogleAuthSettings() {
  const [settings, setSettings] = useState(null);

  useEffect(() => { axios.get(`${API}/settings/google-auth`).then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const toggle = async (key, value) => {
    try {
      const r = await axios.put(`${API}/settings/google-auth`, { ...settings, [key]: value });
      setSettings(r.data);
      toast.success("Google sign-in settings saved");
    } catch (err) { toast.error(getErrorMessage(err)); }
  };

  return (
    <Card className="p-6 border border-gray-200 bg-white" data-testid="google-auth-settings">
      <h3 className="text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2">
        <GoogleLogo size={16} className="text-indigo-500" weight="bold" /> Google Sign-in
      </h3>
      <p className="text-xs text-gray-500 mb-4">Everyone keeps their role (Admin / Sales Team) when signing in with Google.</p>
      <div className="space-y-3">
        {OPTIONS.map((o) => (
          <label key={o.key} className="flex items-start justify-between gap-4 p-3 rounded-lg border bg-gray-50">
            <span>
              <span className="block text-sm font-medium text-gray-800">{o.label}</span>
              <span className="block text-[11px] text-gray-500 mt-0.5">{o.hint}</span>
            </span>
            <Switch checked={!!settings?.[o.key]} disabled={!settings} onCheckedChange={(v) => toggle(o.key, v)} data-testid={`google-setting-${o.key}`} />
          </label>
        ))}
      </div>
    </Card>
  );
}
